/**
 * MusicaAmbiental — elige una pista aleatoria al iniciar cada lectura y
 * la reproduce en loop. Botón flotante 🎵/🔇 para silenciar.
 */
import React, { useEffect, useRef, useState } from 'react';

const TOTAL_TRACKS = 13;

// Recuerda qué pista sonó en la lectura anterior (nivel módulo)
let ultimaPista = 0;

function pistaAleatoria() {
  let n;
  do { n = Math.floor(Math.random() * TOTAL_TRACKS) + 1; }
  while (n === ultimaPista && TOTAL_TRACKS > 1);
  ultimaPista = n;
  return n;
}

function MusicaAmbiental({ volumen = 0.13 }) {
  const audioRef = useRef(null);
  const [silenciado, setSilenciado] = useState(false);
  const [visible, setVisible]       = useState(false);

  useEffect(() => {
    const pista = pistaAleatoria();
    const audio = new Audio();
    audioRef.current = audio;
    audio.volume  = volumen;
    audio.preload = 'auto';
    audio.src     = `/music/${pista}.mp3`;

    // Al terminar la pista, vuelve a reproducirla (loop manual)
    const onEnded = () => { audio.currentTime = 0; audio.play().catch(() => {}); };
    audio.addEventListener('ended', onEnded);

    // Delay para no solaparse con el audio de ElevenLabs
    const t = setTimeout(() => {
      audio.play().catch(() => {});
      setVisible(true);
    }, 1200);

    return () => {
      clearTimeout(t);
      audio.removeEventListener('ended', onEnded);
      audio.pause();
      audio.src = '';
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const toggleSilencio = () => {
    if (!audioRef.current) return;
    const nuevoEstado = !silenciado;
    setSilenciado(nuevoEstado);
    audioRef.current.volume = nuevoEstado ? 0 : volumen;
  };

  if (!visible) return null;

  return (
    <button
      onClick={toggleSilencio}
      title={silenciado ? 'Activar música' : 'Silenciar música'}
      style={{
        position:       'fixed',
        bottom:         '1.2rem',
        right:          '1.2rem',
        zIndex:         200,
        width:          '42px',
        height:         '42px',
        borderRadius:   '50%',
        border:         '1px solid rgba(255,215,0,0.3)',
        background:     'rgba(8,8,18,0.85)',
        backdropFilter: 'blur(8px)',
        cursor:         'pointer',
        fontSize:       '1.1rem',
        display:        'flex',
        alignItems:     'center',
        justifyContent: 'center',
        boxShadow:      silenciado ? 'none' : '0 0 12px rgba(255,215,0,0.15)',
        transition:     'all 0.3s ease',
        opacity:        silenciado ? 0.5 : 1,
      }}
    >
      {silenciado ? '🔇' : '🎵'}
    </button>
  );
}

export default MusicaAmbiental;
